export const createTempBlobDownloadLink = (data: Blob, fileName: string): void => {
  const file = new Blob([data])
  const fileURL = URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = fileURL
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  URL.revokeObjectURL(fileURL)
}
